import React from "react";
import { Link } from "react-router-dom";
import { CourseResource } from "../../../../stores/CoursesStore/Types";

interface Props {
  userIsInUk?: boolean;
  courses?: CourseResource[];
}

const CoursesCard: React.FC<Props> = ({ userIsInUk, courses = [] }) => {
  const imageUrl = (course) => {
    if (userIsInUk && course.preview_headshot_alt_image_url) {
      return course.preview_headshot_alt_image_url;
    }

    if (course.preview_headshot_image_url) {
      return course.preview_headshot_image_url;
    }

    return require("../../../../../../assets/images/courses/decal.png");
  };

  return (
    <div className="hero-visual" aria-hidden="true">
      {courses?.map((course) => (
        <div className="hero-card" key={course.slug}>
          <Link
            to={`/courses/${course.slug}`}
            key={course.slug}
            target="_blank"
          >
            <div className="card-thumb">
              <img
                src={imageUrl(course)}
                alt={`${course.name} course`}
                loading="eager"
                width="210"
                height="160"
              />
            </div>
            <div className="card-body">
              <p className="card-title">{course.name}</p>
              <p>{course.preview_mini_description}</p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default CoursesCard;
